import { LabelHTMLAttributes, PropsWithChildren } from 'react';
import clsx from 'clsx';

import { generateTestId } from './data';
export interface FormControlProps extends PropsWithChildren<{}>, LabelHTMLAttributes<HTMLLabelElement> {
  label?: string;
  hasError?: boolean;
  legend?: string;
  dataTestId: string;
  disabled?: boolean;
  className?: string;
}

const FormControl = (props: FormControlProps) => {
  const { dataTestId, label, hasError, legend, children, className, disabled, ...rest } = props;

  const testIds = generateTestId(dataTestId);

  return (
    <div data-testid={testIds.component} className={clsx('w-full', className)}>
      {label && (
        <label
          {...rest}
          data-testid={testIds.label}
          className={`${disabled && 'opacity-75 cursor-not-allowed'} mb-1 block text-sm font-Onest text-gray-700 dark:text-white`}
        >
          {label}
        </label>
      )}

      <div>{children}</div>

      {legend && (
        <span
          data-testid={testIds.legend}
          className={`${hasError ? 'text-red-700' : 'text-slate-500'} text-xs font-medium`}
        >
          {legend}
        </span>
      )}
    </div>
  );
};

export default FormControl;
